import * as _ from "lodash";

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @category Number
 * @param number The number to clamp.
 * @param [lower] The lower bound.
 * @param upper The upper bound.
 * @returns Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(
    number: number,
    lower: number,
    upper: number
): number {
    return _.clamp(number, lower, upper);
}

/**
 * Creates an array of numbers (positive and/or negative) progressing from start up to, but not including, end.
 * If end is not specified it’s set to start with start then set to 0. If end is less than start a zero-length
 * range is created unless a negative step is specified.
 *
 * @param start The start of the range.
 * @param end The end of the range.
 * @param step The value to increment or decrement by.
 * @return Returns a new range array.
 */
function range(
    start: number,
    end?: number,
    step?: number
): number[] {
    return _.range(start, end, step);
}

/**
 * Calculates n rounded to precision.
 *
 * @param n The number to round.
 * @param precision The precision to round to.
 * @return Returns the rounded number.
 */
function round(
    n: number,
    precision?: number
): number {
    return _.round(n, precision);
}

/**
 * Converts `value` to a number.
 *
 * @category Lang
 * @param value The value to process.
 * @returns Returns the number.
 * @example
 *
 * _.toNumber(3);
 * // => 3
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3');
 * // => 3
 */
function toNumber(value: any): number {
    return _.toNumber(value)
};

export const NumberUtil = {
    clamp, range, round, toNumber
}

export default NumberUtil;